/* eslint-disable no-var */
/* eslint-disable no-plusplus */
/* eslint-disable no-new */
import {firestore} from '../services/firebase'
import { notificationService } from '../services/notificationService'

var loaded = false

firestore().collection("reservations")
  .onSnapshot(querySnapshot => {
    if (!loaded) {
      loaded = true
    } else {
      // eslint-disable-next-line no-restricted-syntax
      for (const change of querySnapshot.docChanges()) {
        // eslint-disable-next-line no-loop-func
        (async () => {
          if (change.type === "added") {
            const shiftDoc = await firestore().collection("shifts").doc(change.doc.data().shiftId).get()
            await notificationService(`Vuoro varattu, ${shiftDoc.data().title}`, false, 'https://hoiwa-app.web.app/apps/shifts-&-gigs/action-center')
          }
        })()
      }
    }
  })
